/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S12_HeadingInputs */

const tr_onbilgi_s12_heading = /** @type {(inputs: Onbilgi_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Yürürlük ve Onay`)
};

const en_onbilgi_s12_heading = /** @type {(inputs: Onbilgi_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Entry into Force and Approval`)
};

const de_onbilgi_s12_heading = /** @type {(inputs: Onbilgi_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Inkrafttreten und Zustimmung`)
};

const ru_onbilgi_s12_heading = /** @type {(inputs: Onbilgi_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Вступление в силу и согласие`)
};

/**
* | output |
* | --- |
* | "12. Entry into Force and Approval" |
*
* @param {Onbilgi_S12_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s12_heading = /** @type {((inputs?: Onbilgi_S12_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S12_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s12_heading(inputs)
	if (locale === "de") return de_onbilgi_s12_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s12_heading(inputs)
	return tr_onbilgi_s12_heading(inputs)
});